import React from "react";
import { useBooking } from "../bookingContext";
import SuccessBookingIcon from "../svg/SuccessBookingIcon";

const SuccessInfo = () => {
  const { trans, bookingData, selectedDate, selectedTime } = useBooking();

  return (
    <>
      <div className="mt-5 mb-4">
        <SuccessBookingIcon />
      </div>
      <div className="fw-bold fs-4 mb-3">
        {trans["Your booking request has been sent!"]}
      </div>
      <div className="mb-3">
        {trans["We’ve received your request for"]}{" "}
        <span className="fw-bold">{bookingData.title}</span>,{" "}
        <span className="fw-bold">
          {selectedDate.toLocaleDateString("en-CA")}
        </span>{" "}
        {trans["at"]} <span className="fw-bold">{selectedTime}</span>.{" "}
        {trans["The organizer will review it shortly."]}
      </div>
      <div className="mb-5">
        {
          trans[
            "You’ll get an email confirmation once your booking is approved."
          ]
        }
      </div>
    </>
  );
};

export default SuccessInfo;
